var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.64,
    height: 16.641,
    viewBox: "0 0 16.64 16.641",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_Instagram_Color_1435162",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_142_",
    d: "M142.9,205.968a4.242,4.242,0,0,0-2.43-2.431,6.071,6.071,0,0,0-2.019-.386c-.887-.039-1.17-.051-3.434-.051s-2.546.006-3.434.051a6.037,6.037,0,0,0-2.019.386,4.242,4.242,0,0,0-2.43,2.431,6.07,6.07,0,0,0-.386,2.019c-.039.887-.051,1.17-.051,3.434s.006,2.546.051,3.434a6.036,6.036,0,0,0,.386,2.019,4.242,4.242,0,0,0,2.43,2.431,6.072,6.072,0,0,0,2.019.386c.887.039,1.17.051,3.434.051s2.546-.006,3.434-.051a6.037,6.037,0,0,0,2.019-.386,4.242,4.242,0,0,0,2.43-2.431,6.07,6.07,0,0,0,.386-2.019c.039-.887.051-1.17.051-3.434s-.006-2.546-.051-3.434A6.036,6.036,0,0,0,142.9,205.968Zm-1.112,8.815a4.547,4.547,0,0,1-.289,1.543,2.577,2.577,0,0,1-.624.958,2.605,2.605,0,0,1-.958.624,4.586,4.586,0,0,1-1.543.289c-.881.039-1.138.051-3.363.051s-2.488-.006-3.363-.051a4.548,4.548,0,0,1-1.543-.289,2.577,2.577,0,0,1-.958-.624,2.6,2.6,0,0,1-.624-.958,4.586,4.586,0,0,1-.289-1.543c-.039-.881-.051-1.145-.051-3.363s.006-2.488.051-3.363a4.548,4.548,0,0,1,.289-1.543,2.577,2.577,0,0,1,.624-.958,2.6,2.6,0,0,1,.958-.624,4.585,4.585,0,0,1,1.543-.289c.881-.039,1.145-.051,3.363-.051s2.488.006,3.363.051a4.547,4.547,0,0,1,1.543.289,2.577,2.577,0,0,1,.958.624,2.605,2.605,0,0,1,.624.958,4.585,4.585,0,0,1,.289,1.543c.039.881.051,1.145.051,3.363S141.829,213.909,141.791,214.783Z",
    transform: "translate(-126.7 -203.1)",
    fill: "#222631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_145_",
    d: "M194.258,266a4.262,4.262,0,1,0,4.759,4.233A4.521,4.521,0,0,0,194.258,266Zm0,6.982a2.768,2.768,0,1,1,3.091-2.75A2.936,2.936,0,0,1,194.258,272.982Z",
    transform: "translate(-185.944 -261.912)",
    fill: "#222631"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_143_",
    cx: 1.007,
    cy: 1.007,
    rx: 1.007,
    ry: 1.007,
    transform: "translate(11.743 2.876)",
    fill: "#222631"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.5af94a805c39b6ec13c9f568a201595f.svg";
export { ForwardRef as ReactComponent };